import { z } from 'zod';
export const EmailLogEntry = z.object({
    id: z.string().uuid(),
    result: z.enum(['SENT', 'FAILED']),
    messageId: z.string().nullable(),
    error: z.string().nullable(),
    sentAt: z.string().datetime(),
});
export const EmailLogResponse = z.object({
    logs: z.array(EmailLogEntry),
});
export const SendEmailResponse = z.object({
    attendeeId: z.string().uuid(),
    /** Go envia `null` cuando el correo se suprimio (destinatario demo) o el mailer no dio id. */
    messageId: z.string().nullable(),
    sentAt: z.string().datetime(),
});
export const SendAllRequest = z.object({
    onlyPending: z.boolean().optional().default(true),
});
export const SendAllProgressEvent = z.object({
    attendeeId: z.string().uuid(),
    status: z.enum(['sent', 'failed', 'skipped']),
    messageId: z.string().optional(),
    error: z.string().optional(),
    progress: z.object({
        done: z.number().int().nonnegative(),
        total: z.number().int().nonnegative(),
    }),
});
//# sourceMappingURL=email.js.map